var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multi-label-text-cell"},_vm._l((_vm.labelsAndTexts),function(labelAndText,i){return _c('div',{key:("label_text_" + i),staticClass:"label-text"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(labelAndText.label))]),_c('span',{staticClass:"text",class:{
        'ml-1': labelAndText.label,
        'font-bold': labelAndText.textIsBold
      }},[_vm._v("\n      "+_vm._s(labelAndText.text)+"\n    ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }